import React, { Component, Suspense } from "react";
import { Router as BrowerRouter, Switch, Route, Redirect } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { lightTheme, darkTheme } from "theme";
import { FaSun, FaMoon } from "react-icons/fa";
import { defaultRoute } from "routes/routes-list";
import history from "routes/history";
import Error from "components/Error";
import Loading from "components/Loading";
import Main from "modules/Main";
import GlobalStyles from "./Global";

class App extends Component {
  state = {
    noInternetConnection: false,
    darkMode: false
  };
  componentDidMount() {
    this.handleInternetConnectionChange();
    window.addEventListener("online", this.handleInternetConnectionChange);
    window.addEventListener("offline", this.handleInternetConnectionChange);
  }
  handleInternetConnectionChange = () => {
    navigator.onLine ? this.setState({ noInternetConnection: false }) : this.setState({ noInternetConnection: true });
  };
  toggleDarkMode = () => {
    this.setState({ darkMode: !this.state.darkMode });
  };
  render() {
    const { noInternetConnection, darkMode } = this.state;
    const { toggleDarkMode } = this;
    if (noInternetConnection) {
      return <Error text="No Internet Connnection" />;
    }
    return (
      <ThemeProvider theme={darkMode === false ? lightTheme : darkTheme}>
        <GlobalStyles />
        <Suspense fallback={<Loading />}>
          <BrowerRouter history={history}>
            <div className="toggle">
              <button className="toggle-button" onClick={toggleDarkMode}>
                {darkMode ? <FaSun /> : <FaMoon />}
              </button>
            </div>
            <Switch>
              <Route path={defaultRoute} component={Main} />
              <Redirect to={defaultRoute} />
            </Switch>
          </BrowerRouter>
        </Suspense>
      </ThemeProvider>
    );
  }
}

export default App;
